import * as React from 'react';

import type { IconProps } from './types';

export const Star = React.forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="m600.44 73.944 90.359 181.716c12.176 25.13 44.859 48.972 72.413 54.129l163.412 27.064c104.455 17.398 128.81 93.436 53.828 169.476L852.93 634.56c-21.154 21.264-33.323 63.147-26.275 93.43l36.522 158.523c28.844 125.012-37.811 173.986-147.395 108.252l-153.155-91.502c-27.554-16.751-73.7-16.751-101.255 0l-153.161 91.502c-109.584 65.084-176.231 16.76-147.393-108.252l36.529-158.523c7.049-29.636-5.127-71.526-26.275-93.43L43.545 506.329c-74.979-75.395-50.626-151.432 53.83-169.476l163.416-27.064c27.557-4.512 60.239-28.997 72.415-54.129l90.357-181.716c48.063-98.591 127.527-98.591 176.875 0z"
      fill={color}
    />
  </svg>
));

export default Star;
